import React from 'react';
import AddressName from '../Components/AddressName';
import { connect } from 'react-redux';
import NumberFormatter from '../Components/NumberFormatter';

const mapStateToProps = state => {
  return {
    currentAccount: state.account.currentAccount,
    asyncCoinBalance: state.account.asyncCoinBalance,
    totalSupply: state.account.totalSupply,
    ethereumBalance: state.account.ethereumBalance
  };
};

const ConnectedWalletInformation = ({currentAccount, asyncCoinBalance, totalSupply, ethereumBalance}) => (
  <div className="c-component c-wallet-information">
    <h2>Wallet Information</h2>
    <div>Account: <AddressName address={currentAccount}/></div>
    <div>ASC Balance: <strong><NumberFormatter number={asyncCoinBalance || 0}/> ASC</strong></div>
    <div>ASC In Circulation: <strong><NumberFormatter number={totalSupply || 0}/> ASC</strong></div>
    <div>ETH Balance: <strong><NumberFormatter number={ethereumBalance || 0}/> ETH</strong></div>
  </div>
);

const WalletInformation = connect(mapStateToProps)(ConnectedWalletInformation);

export default WalletInformation;



// WEBPACK FOOTER //
// ./src/components/HomePage/WalletInformation.js